import * as React from 'react';
import { SVGProps } from 'react';

const IconReplySizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m16 7-6-5v3c-6 0-9 2-9 5 0 1.5.5 3 2 4-.5-1.5-1-5 7-5v3l6-5z" />
  </svg>
);
export default IconReplySizeS;
